import { Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import { AppComponentBase } from '@shared/app-component-base';
import { StatusList } from '@shared/model/status-consulta-enum.model';
import { ConsultaDto, ConsultaServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-edit-status-consulta',
  templateUrl: './edit-status-consulta.component.html',
  styleUrls: ['./edit-status-consulta.component.scss']
})
export class EditStatusConsultaComponent extends AppComponentBase {

  @Input() consulta: ConsultaDto;
  @Output() onSave = new EventEmitter<any>();
  public statusConsulta: StatusList = new StatusList();
  public saving: boolean = false;

  constructor(
    inject: Injector,
    private readonly _consultaService: ConsultaServiceProxy,
    public bsModalRef: BsModalRef,
  ) {
    super(inject)
  }

  protected save():void {
    if(!this.consulta.statusConsulta){
      abp.notify.info("Informe o status da consulta!");
      return;
    }

    abp.ui.setBusy()
    this.saving = true;
    this._consultaService.alterarStatus(this.consulta.id, this.consulta.statusConsulta).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.onSave.emit();
      this.bsModalRef.hide();
    });
  }
}
